import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as BundlesReducer } from './Bundles'
import { default as BundlesFormReducer } from './BundlesForm'
import { default as BundlesRatesReducer } from './BundlesRates'

export * from './Bundles'
export * from './BundlesForm'
export * from './BundlesRates'

export const types = {
  ...makeApiTypes('FETCH_PARENT_BUNDLES', 'bundles'),
  ...makeApiTypes('FETCH_PARENT_BUNDLES_QUESTIONS', 'bundles'),
  ...makeApiTypes('FETCH_BUNDLE_DETAILS', 'bundles'),
  ...makeApiTypes('FETCH_BUNDLE_INFO_WITH_ESTIMATE', 'bundles'),
  ...makeApiTypes('FETCH_BUNDLE_INFO_WITH_SIBLING_ESTIMATES', 'bundles'),
  ...makeApiTypes('FETCH_PLAN_ID', 'bundles'),
  ...makeApiTypes('SEARCH_FOR_DOCTORS', 'bundles'),
  ...makeApiTypes('FETCH_PROVIDER_RATES', 'bundles'),
  ...makeApiTypes('FETCH_PRACTICE_RATES', 'bundles'),
  ...makeApiTypes('LOCK_BUNDLE', 'bundles'),
  ['CLEAR_DOCTORS']: 'bundles/CLEAR_DOCTORS',
  ['CLEAR_RATES']: 'bundles/CLEAR_RATES',
  ['CLEAR_BUNDLE_DETAILS']: 'bundles/CLEAR_BUNDLE_DETAILS',
  ['CLEAR_BUNDLE_INFO_WITH_ESTIMATE']:
    'bundles/CLEAR_BUNDLE_INFO_WITH_ESTIMATE',
  ['CLEAR_BUNDLE_INFO_WITH_SIBLING_ESTIMATES']:
    'bundles/CLEAR_BUNDLE_INFO_WITH_SIBLING_ESTIMATES',
  ['CLEAR_PARENT_BUNDLE_QUESTIONS']: 'bundles/CLEAR_PARENT_BUNDLE_QUESTIONS',
  ['UPDATE_ANSWER']: 'bundles/UPDATE_ANSWER',
  ['UPDATE_FORM_DATA']: 'bundles/UPDATE_FORM_DATA',
  ['CLEAR_FORM']: 'bundles/CLEAR_FORM',
  ['SET_ACTIVE_QUESTIONS']: 'bundles/SET_ACTIVE_QUESTIONS',
  ['SET_API_CALL_ID']: 'bundles/SET_API_CALL_ID',
}

export const initialState = {
  apiCallId: '',
  parentBundles: { busy: false, error: '', entities: null },
  parentBundleQuestions: { busy: false, error: '', entity: null },
  bundleDetails: {
    busy: false,
    error: '',
    entity: null,
    requestedParentBundleId: null,
  },
  bundleInfoWithEstimate: { busy: false, error: '', entity: null },
  bundleInfoWithSiblingEstimates: { busy: false, error: '', entity: null },
  doctors: {
    busy: false,
    error: '',
    entities: null,
    page: null,
    size: 20,
    isLastPageReached: false,
  },
  rates: {
    busy: false,
    error: '',
    entities: null,
    page: null,
    size: 20,
    isLastPageReached: false,
  },
  planId: {
    busy: false,
    error: '',
    entity: null,
  },
  lock: {
    busy: false,
    error: '',
    entity: null,
  },
  form: { answers: {}, activeQuestions: [] },
}

export default reduceReducers(
  BundlesReducer,
  BundlesFormReducer,
  BundlesRatesReducer,
  // initialState MUST be last
  initialState,
)
